module.exports = __webpack_public_path__ + "img/category.061bd0d9.svg";